
	import Vue from "vue";

	export default Vue.extend({
		name: "LongAnswerField",
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			label: {
				type: String,
				default: "",
			},
      required: {
        type: Boolean,
        default: false,
      },
      extraValidations: {
        type: Boolean,
        default: false,
      },
      validation: {
        type: String,
        default: ""
      },
			value: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				textValue: this.value,
			};
		},
    methods: {
      getExtraValidations(): any {
        if (!this.extraValidations) return [];
          if(this.validation === 'email') {
            return [this.$v.email(this.$t('forms.form.validations.email'))];
          } else if (this.validation === 'phone') {
            return [this.$v.phone(this.$t('forms.form.validations.phone'))];
          } else if (this.validation === 'rut') {
            return [this.$v.rut(this.$t('forms.form.validations.rut'))];
          } else {
            return [];
          }
      }
    },
		watch: {
      value: function (value) {
        this.textValue = value;
      },
			textValue: function (value) {
				this.textValue = value;
				this.$emit("input", value);
			},
		},
	});
